import { render, staticRenderFns } from "./officialAccountInfo.vue?vue&type=template&id=7f580c04&scoped=true&"
import script from "./officialAccountInfo.vue?vue&type=script&lang=js&"
export * from "./officialAccountInfo.vue?vue&type=script&lang=js&"
import style0 from "./officialAccountInfo.vue?vue&type=style&index=0&id=7f580c04&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f580c04",
  null
  
)

export default component.exports